import React from 'react';
import './styles/Home.css';

const Home = () => {
  return (
    <section id="home" className="home-section">
      <div className="home-content">
        <h1>Hello, I'm <span className="highlight">Samuel G. Adabor</span></h1>
        <h2>FullStack Web Developer</h2>
        <p>I create beautiful and functional websites with modern technologies</p>
        <div className="cta-buttons">
          <a href="#projects" className="btn primary-btn">View My Work</a>
          <a href="#contact" className="btn secondary-btn">Contact Me</a>
        </div>
      </div>
      <div className="social-icons">
        <a href="https://github.com/t-phage" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-github"></i>
        </a>
        <a href="https://linkedin.com/in/samuel-adabor-8b65b019a" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-linkedin"></i>
        </a>
        <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-twitter"></i>
        </a>
      </div>
    </section>
  );
};

export default Home;